module.exports = __webpack_public_path__ + "static/media/logout-gray.b25bceea.svg";